/* eslint-disable camelcase */

import TWIACoveragesHelper from "./TWIACoveragesHelper";

const TWIAHoCoveragesUtil = () => {
    const DW_PROP_COVERAGES_VALUATION_TYPE_COVTERM_ID = 'zk4giclph3greemn3rnr0cg3ko9';
    const DW_PROP_COVERAGES_STRUCTURE_LIMIT_COVTERM_ID = 'z1ejuk2umgcg1a8f7k8t5taihe9';
    const DW_PROP_COVERAGE_PUBLIC_ID = 'TW_DW_Property_Coverages';

    const getBaseCoverageAndAdditionalFields = ({ value }) => {
        const { lobData: { homeowners: { offerings: [offer] = [] } = {} } = {} } = value;
        const { coverages: { baseCoverages, coveragesAdditionalFields_TWIA } = {} } = { ...offer };

        return {
            baseCoverages,
            coveragesAdditionalFields_TWIA
        };
    }

    const isStructureLimitLess80PercentRCVForTWRD = ({ coveragesAdditionalFields_TWIA, baseCoverages }) => {
        if (coveragesAdditionalFields_TWIA === undefined || baseCoverages === undefined) {
            return false;
        }

        const { replacementCashValue_TWIA: rcv, hoPolicyType_TWIA: policyType } = coveragesAdditionalFields_TWIA;
        const isTWRDPolicyType = policyType === 'TWRD';

        if (!isTWRDPolicyType) {
            return false;
        }

        const coveragesHelper = TWIACoveragesHelper(baseCoverages);

        const { chosenTerm: chosenValuationId } = coveragesHelper.getCoverageTerm({
            coveragePublicID: DW_PROP_COVERAGE_PUBLIC_ID,
            termPublicID: DW_PROP_COVERAGES_VALUATION_TYPE_COVTERM_ID
        });
        const DW_PROP_COVERAGES_VALUATION_TYPE_COV_TERM_OPTION_ACTUAL_CASH_VALUE_ID = 'zi3jqvoi5iooo7ogedj69r0vc9a';
        const isActualCashValue = chosenValuationId === DW_PROP_COVERAGES_VALUATION_TYPE_COV_TERM_OPTION_ACTUAL_CASH_VALUE_ID;

        if (!isActualCashValue) {
            return false;
        }

        const { directValue: limit } = coveragesHelper.getCoverageTerm({
            coveragePublicID: DW_PROP_COVERAGE_PUBLIC_ID,
            termPublicID: DW_PROP_COVERAGES_STRUCTURE_LIMIT_COVTERM_ID
        });

        return limit <= 0.8 * rcv;
    };


    const isValuationMethodReplacementCostACVR = ({ coveragesAdditionalFields_TWIA, baseCoverages }) => {
        if (coveragesAdditionalFields_TWIA === undefined || baseCoverages === undefined) {
            return false;
        }

        const { hoPolicyType_TWIA: policyType } = coveragesAdditionalFields_TWIA;
        const isTWRDPolicyType = policyType === 'TWRD';

        if (!isTWRDPolicyType) {
            return false;
        }

        const DW_PROP_COVERAGES_VALUATION_TYPE_COV_TERM_OPTION_REPLACEMENT_COST_ACV_ID = 'z6mh4k1dph98u5jfdc3eipq43ea';
        const coveragesHelper = TWIACoveragesHelper(baseCoverages);
        const { chosenTerm: chosenValuationId } = coveragesHelper.getCoverageTerm({
            coveragePublicID: DW_PROP_COVERAGE_PUBLIC_ID,
            termPublicID: DW_PROP_COVERAGES_VALUATION_TYPE_COVTERM_ID
        });

        return chosenValuationId === DW_PROP_COVERAGES_VALUATION_TYPE_COV_TERM_OPTION_REPLACEMENT_COST_ACV_ID;
    };

    return {
        isStructureLimitLess80PercentRCVForTWRD,
        isValuationMethodReplacementCostACVR,
        getBaseCoverageAndAdditionalFields
    };

};

export default TWIAHoCoveragesUtil();
